import { Pipe, PipeTransform } from '@angular/core';

/*
 */
@Pipe({name: 'cleanPhoneNumberPipe'})
export class CleanPhoneNumberPipe implements PipeTransform {
  transform(input: string): string {
    const xForm = new NumberToAlpha();
    const nonAlpha = input
      .replace(/ *\([^)]*\)|\s|[^A-z0-9] */gi, '')
      .split('')
      .map( value => xForm.getNumber(value));

    return nonAlpha.join('');
  }
}


class NumberToAlpha {
  phonePad = [
    { 'A': '2', 'B': '2', 'C': '2'},
    { 'D': '3', 'E': '3', 'F': '3'},
    { 'G': '4', 'H': '4', 'I': '4'},
    { 'J': '5', 'K': '5', 'L': '5'},
    { 'M': '6', 'N': '6', 'O': '6'},
    { 'P': '7', 'Q': '7', 'R': '7', 'S': '7'},
    { 'T': '8', 'U': '8', 'V': '8'},
    { 'W': '9', 'X': '9', 'Y': '9', 'Z': '9'},
  ];

  constructor() {
  }

  getNumber(letter) {
    if (/^[A-z]+$/.test(letter)) {
      let retValue = letter;
      this.phonePad.map( (key) => {
        if (key.hasOwnProperty(letter.toUpperCase())) {
          retValue = key[letter.toUpperCase()];
        }
      });
      return retValue;
    } else {
      return letter;
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/pipe/clean-phone-number.pipe.ts